import { render, staticRenderFns } from "./PortfolioCategory.vue?vue&type=template&id=97d50c40&"
import script from "./PortfolioCategory.vue?vue&type=script&lang=js&"
export * from "./PortfolioCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports